import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@/services/authentication.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-login-guest',
    templateUrl: './login-guest.component.html',
    styleUrls: ['./login-guest.component.scss'],
    standalone: true
})
export class LoginGuestComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.authenticationService.connectGuest(returnUrl);
  }
}
